module.exports = __webpack_public_path__ + "img/8.4e1220cf.png";